import {
    Toast
} from "vant";
/**
 * @desc 函数防抖
 * @param func 目标函数
 * @param wait 延迟执行毫秒数
 * @param immediate true - 立即执行， false - 延迟执行
 */
export const debounce = function(func, wait = 1000, immediate = true) {
	let timer;
	return function() {
		
		let context = this,
			args = arguments;
		if (timer) clearTimeout(timer);
		if (immediate) {
			let callNow = !timer;
			timer = setTimeout(() => {
				timer = null;
			}, wait);
			if (callNow) func.apply(context, args);
			else {
				Toast('请稍等...');
			}
		} else {
			timer = setTimeout(() => {
				func.apply(context, args);
			}, wait)
		}
	}
}
/**
 * @desc 函数节流
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param type 1 使用表时间戳，在时间段开始的时候触发 2 使用表定时器，在时间段结束的时候触发
 */
export const throttle = (func, wait = 1000, type = 1) => {
	let previous = 0;
	let timeout;
	return function() {
		let context = this;
		let args = arguments;
		if (type === 1) {
			let now = Date.now();

			if (now - previous > wait) {
				func.apply(context, args);
				previous = now;
			}
		} else if (type === 2) {
			if (!timeout) {
				timeout = setTimeout(() => {
					timeout = null;
					func.apply(context, args)
				}, wait)
			}
		}
	}
}

/**
 * @desc 日期格式化
 * @param dateStr 日期字符串
 * @param format 格式
 */
export const formatDateTime = (dateStr, format) => {
	var d = new Date(dateStr.replace(/-/g, '/'));
	
    var map = {
        'yyyy': d.getFullYear(),
        'mm': ("0" + (d.getMonth() + 1)).slice(-2),
        'dd': ("0" + d.getDate()).slice(-2),
        'hh': ("0" + d.getHours()).slice(-2),
        'mi': ("0" + d.getMinutes()).slice(-2),
        'ss': ("0" + d.getSeconds()).slice(-2)
    };

    return format.replace(/yyyy|mm|dd|hh|mi|ss/gi, function(matched) {
        return map[matched];
    });
}